/**
 * Shared runtime context for hit-base services (keycloak, appContext, i18n).
 * Values are assigned during bootstrap in main.ts (loadApp).
 * @type {{$appContext: {}, $keycloak: {}, $i18n: null}}
 */
export const globals = {
  $i18n: null,
  $keycloak: {
    tokenParsed: {},
    idTokenParsed: {},
  },
  $appContext: {},
};
